import { render, staticRenderFns } from "./BlogCoverPreview.vue?vue&type=template&id=012f90e8&"
import script from "./BlogCoverPreview.vue?vue&type=script&lang=js&"
export * from "./BlogCoverPreview.vue?vue&type=script&lang=js&"
import style0 from "./BlogCoverPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports